module.exports = __webpack_public_path__ + "img/hong-8.cd77bbfc.png";